export default __webpack_public_path__ + "static/element_solutions_1-0a3aac1cda1dc02299c780c993dc5fbe.png";